<template>
    <section class="team-area section-padding fix section" id="team">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="section-title title-style-5 text-center">
                        <h2 class="title">Teknologjia ne Helios Med</h2>
                        <p class="paragraph">Ne operojme me fjalën më fundit të teknologjisë, me aparatura e reagent me sistem automatik. Informatizim i plotë i regjistrimit të të dhënave dhe rezultateve.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <carousel class="doctor-team-carousel"
                        :item = "3"
                        :nav = "false"
                        :dots = "false"
                        :autoplay = "true"
                        :margin = "30"
                        :loop = "true"
                        :smartSpeed = "300"
                        :responsive="{0:{items:1},576:{items:2},768:{items:3}}"
                    >
                        <div v-for="(doctor, doctors) in doctors" :key="doctors" class="doctor-member">
                            <div class="doctor-thumb">
                                <img :src="doctor.thumb" alt="doctor thumb">
                                <div class="doctor-content">
                                    <h6 class="title">{{ doctor.title }}</h6>
                                    <p class="designation">{{ doctor.designation }}</p>
                                </div>
                            </div>
                        </div>
                    </carousel>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import carousel from 'vue-owl-carousel'
    export default {
        name: 'TeamDoctor',
        components: {
            carousel 
        },
        data (){
            
            return {
                doctors:[
                    {
                        title: "EUROBlotOne/EuroBlotMaster", 
                        designation: "Diagnozë e saktë e alergjive përmes profileve të shumëfishta.", 
                        thumb: require("../assets/img/home-medical/team/product-euroblot.jpg")
                    },
                    {
                        title: "Sysmex XS-1000i Automated Hematology Analyzer", 
                        designation: "Teknologjia e fundit nga Sysmex per rezultate te sakta ne imtesi", 
                        thumb: require("../assets/img/home-medical/team/xs1000.png")
                    },
                    {
                        title: "Cobas 400 plus", 
                        designation: "Aparati është i projektuar për konsolidimin e testeve dhe rritjen e eficencës, në të njëjtën kohë kjo shoqërohet me nje ulje të kostos laboratorike. Cobas 400 plus është analizatori më i përshtatshëm për analizimin e testeve kimike", 
                        thumb: require("../assets/img/home-medical/team/cobas400.jpg")
                    },
                    {
                        title: "AIA-360 Automated Immunoassay Analyzer", 
                        designation: "Kryen diagnoza te sofistikuara me nje analizues komapkt.", 
                        thumb: require("../assets/img/home-medical/team/aia360.jpg")
                    },
                    {
                        title: "DCA Voltage Analyzer", 
                        designation: "Eshte nje sistem qe ndihmon per kontrollin e glicemise dhe te zbuloni semundje te hereshme te veshkave", 
                        thumb: require("../assets/img/home-medical/team/dca.jpg")
                    },
                    {
                        title: "Cobas e411", 
                        designation: "Për analiza imunologjike serum ose plazëm. Sistemi i diskut të Cobas e 411 disk përmban dy pozicione tëgatshme për mostrën e STAT, duke dhënë rezultate të shpejtë nëpërgjigje të kërkesave të personelit", 
                        thumb: require("../assets/img/home-medical/team/cobas400.jpg")
                    },
                    
                ],
                bgImg: {
                    backgroundImage: `url(${require('../assets/img/home-medical/slider/1-bg.jpg')})`
                },
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/team.scss';
</style>
